import { Reservation } from "@glidevvr/reservation-app";
import "@glidevvr/reservation-app/styles.css";
import { useSelector } from "react-redux";
import type { RootState } from "@/store";
import { ReservationType } from "@/types/enums";
import type { UnitGroup } from "@/types";

interface InlineReservationFormProps {
    unitGroup: UnitGroup;
    selectedPromo: number;
    // "lead" = Get a Quote (SOFT); "reserve" = booking (HARD). Defaults to lead.
    mode?: "lead" | "reserve";
    // When set, render a back (X) to the selector — multi-promo step only.
    onBack?: () => void;
}

// Layout 2 expanded-row form: reservation-app's compact variant; mode picks lead (Quote) vs reserve (booking).
export const InlineReservationForm = ({
    unitGroup,
    selectedPromo,
    mode = "lead",
    onBack,
}: InlineReservationFormProps) => {
    const apiKey = useSelector((state: RootState) => state.apiKey.apiKey);
    // Follow the host-provided environment (same source as the widget's data calls), not a build-time constant.
    const environment = useSelector(
        (state: RootState) => state.apiKey.environment,
    );

    const isLead = mode === "lead";

    // Surface the chosen promo in the form (the row/selector visual scrolls away).
    const selectedPromoName = unitGroup.rates.promo_rates.find(
        (promo) => promo.id === selectedPromo,
    )?.name;

    return (
        <div className="quote-form">
            {onBack && (
                <button
                    type="button"
                    className="quote-form__back"
                    onClick={onBack}
                    aria-label="Back to promotional discounts"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <path
                            d="M4 4l8 8M12 4l-8 8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
            )}
            <Reservation
                apiKey={apiKey}
                environment={environment}
                facilityId={unitGroup.representative_unit.facility_id}
                unitId={Number(unitGroup.representative_unit.id)}
                promotionId={Number(selectedPromo)}
                reservationType={isLead ? ReservationType.SOFT : ReservationType.HARD}
                showDetails={false}
                leadMode={isLead}
                compact={true}
                selectedPromoName={selectedPromoName}
            />
        </div>
    );
};
